import Navbar from "./components/Navbar";
import Main from "./components/layouts/Main";
import "./App.css";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Navbar />
      <Main />
      <Footer />
    </>
  );
}

export default App;
